jQuery(document).ready(function($){
    $('#dynamic-map').each(function(){
        var departements = {
            'FR-28': 0,
            'FR-29': 0,
            'FR-22': 0,
            'FR-23': 0,
            'FR-21': 0,
            'FR-26': 0,
            'FR-27': 0,
            'FR-24': 0,
            'FR-25': 0,
            'FR-MQ': 0,
            'FR-94': 0,
            'FR-93': 0,
            'FR-92': 0,
            'FR-91': 0,
            'FR-90': 0,
            'FR-17': 0,
            'FR-16': 0,
            'FR-15': 0,
            'FR-14': 0,
            'FR-13': 0,
            'FR-12': 0,
            'FR-11': 0,
            'FR-10': 0,
            'FR-2B': 0,
            'FR-2A': 0,
            'FR-19': 0,
            'FR-18': 0,
            'FR-88': 0,
            'FR-89': 0,
            'FR-80': 0,
            'FR-81': 0,
            'FR-82': 0,
            'FR-83': 0,
            'FR-84': 0,
            'FR-85': 0,
            'FR-86': 0,
            'FR-87': 0,
            'FR-01': 0,
            'FR-02': 0,
            'FR-03': 0,
            'FR-04': 0,
            'FR-05': 0,
            'FR-06': 0,
            'FR-07': 0,
            'FR-08': 0,
            'FR-09': 0,
            'FR-RE': 0,
            'FR-75': 0,
            'FR-74': 0,
            'FR-77': 0,
            'FR-76': 0,
            'FR-71': 0,
            'FR-70': 0,
            'FR-73': 0,
            'FR-72': 0,
            'FR-79': 0,
            'FR-78': 0,
            'FR-YT': 0,
            'FR-66': 0,
            'FR-67': 0,
            'FR-64': 0,
            'FR-65': 0,
            'FR-62': 0,
            'FR-63': 0,
            'FR-60': 0,
            'FR-61': 0,
            'FR-68': 0,
            'FR-69': 0,
            'FR-53': 0,
            'FR-52': 0,
            'FR-51': 0,
            'FR-50': 0,
            'FR-57': 0,
            'FR-56': 0,
            'FR-55': 0,
            'FR-54': 0,
            'FR-59': 0,
            'FR-58': 0,
            'FR-48': 0,
            'FR-49': 0,
            'FR-44': 0,
            'FR-45': 0,
            'FR-46': 0,
            'FR-47': 0,
            'FR-40': 0,
            'FR-41': 0,
            'FR-42': 0,
            'FR-43': 0,
            'FR-95': 0,
            'FR-GF': 0,
            'FR-GP': 0,
            'FR-39': 0,
            'FR-38': 0,
            'FR-31': 0,
            'FR-30': 0,
            'FR-33': 0,
            'FR-32': 0,
            'FR-35': 0,
            'FR-34': 0,
            'FR-37': 0,
            'FR-36': 0,
        };
        var $map = $(this);
        require('../../static/jvector-map-assets/jquery-jvectormap-2.0.3.min.js');
        require('../../static/jvector-map-assets/jquery-jvectormap-fr-merc');
        $.get(bundle_object.ajaxurl, {
            action: 'get_map_user_data'
        }, function(data){

            var departements = jQuery.parseJSON(data);
            // departements = jQuery.extend(departements, departementData);
            console.log(departements);
            $map.vectorMap({
                map: 'fr_merc', 
                zoomOnScroll: false,
                regionStyle: {
                    initial: {
                        stroke: '#a1a3a4',
                        "stroke-width": 1,
                        "stroke-opacity": 1
                    }
                },
                series: {
                    regions: [{
                        attribute: 'fill',
                        values: departements,
                        scale: ['#A3D6E0', '#00356E'],
                        normalizeFunction: 'polynomial'
                    }]
                },
                onRegionTipShow: function (e, el, code) {
                    $(el).css('color', '#555555').css('border-color', '#555555');
                    $(el).css('background-color', $('.jvectormap-region[data-code=' + code + ']').attr('fill'));
                    if (typeof departements[code] === 'undefined') {
                        
                    } else {
                        $(el).css('color', '#ffffff').css('border-color', '#ffffff');
                        if (departements[code] == 1) {
                            el.html(el.html() + ' (' + departements[code] + ' '+ bundle_object.member+')');
                        } else {
                            el.html(el.html() + ' (' + departements[code] + ' ' + bundle_object.members +')');
                        }
                    }
                }
                
            });
        })

        
        
        
    })
});